import axios from 'axios';

const ep_list_mayday = `${process.env.VUE_APP_PB_API}/ags/contingency-plan/all`;
const ep_single_qr = `${process.env.VUE_APP_PB_API}/ags/contingency-plan/single-qr`;

const listMayday = (data) => {
    console.log('listMaydayData:', `${ep_list_mayday}?page=${data.current_page}`);
    let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${ep_list_mayday}?page=${data.current_page}`,
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const singleQR = (qrcode) => {
    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: ep_single_qr,
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({ qrcode }),
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

export {
    listMayday, singleQR
}